import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for P.F. Candle Co.'s "Teakwood & Tobacco - 7.2 oz
// Standard Candle" (p_2d12vzoz), pulled from Faire's live
// `GET /api/product-reviews/product/{product_token}` endpoint (the same data
// source that powers the product's own PDP review list) — verbatim comment,
// real reviewer, real rating, real publish date.
export const review_pfc1: FaireReviewEntity = {
  token: "review_pfc1",
  type: "review",
  brandName: "P.F. Candle Co.",
  brandToken: "b_a9b3b023",
  productToken: "p_2d12vzoz",
  reviewType: "product",
  reviewerName: "Tina Nivens",
  reviewerLocation: "Farmersville, TX, United States",
  stars: 5,
  reviewText:
    "Love this product and love to light it up and simply just relax or give a warm welcoming fragrance to my guests and neighbors who come over.",
  reviewDate: "Jul 30, 2025",
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:49:30.000Z",
    importedBy: "entity-db-cli",
  },
};
